import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";

const ZoomLockController = ({ zoomLevelName, position }) => {
  const map = useMap();
  const prevZoomLevelName = useRef(null);

  useEffect(() => {
    if (!map) return;
    const zoomLevels = {
      highway: 10,      // Show whole UAE
      street: 12,
      building: 16,
      default: 10,
    };
    const fixedZoom = zoomLevels[zoomLevelName] || zoomLevels["default"];

    let targetZoom = map.getZoom();
    if (prevZoomLevelName.current !== zoomLevelName) {
      targetZoom = fixedZoom;
    }

    const [lat, lng] = position || [];
    const [prevLat, prevLng] = prevZoomLevelName.current?.position || [];

    // Only set view if zoom changed or position actually changed substantially
    // or if this is the first run (prevZoomLevelName.current might be null)
    if (
      prevZoomLevelName.current?.name !== zoomLevelName ||
      lat !== prevLat ||
      lng !== prevLng
    ) {
      map.setView(position, targetZoom);
    }

    // map.setView(position, targetZoom); // 👈 important: set both zoom & center
    map.touchZoom.disable();
    map.boxZoom.disable();
    map.keyboard.disable();
    const zoomControl = document.querySelector(".leaflet-control-zoom");
    if (zoomControl) zoomControl.style.display = "none";

    prevZoomLevelName.current = { name: zoomLevelName, position };

    return () => {
      map.scrollWheelZoom.enable();
      map.doubleClickZoom.enable();
      map.touchZoom.enable();
      map.boxZoom.enable();
      map.keyboard.enable();
      map.dragging.enable();

      if (zoomControl) zoomControl.style.display = "block";
    };
  }, [zoomLevelName, map, position]);

  return null;
};
export default ZoomLockController;